import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

/*
  Generated class for the RelatoriosContabeisService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class RelatoriosContabeisService {

  constructor(http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  /* ======================================================================
  *
  *  Apagar abaixo
  *
  ========================================================================= */

  obterListaRelatorios(): Observable<any> {
    let urlObtencaoDados: string = "contabilidadeBalanco/listar/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  submeterRelatorio(relatorio): Observable<any> {
    let urlObtencaoDados: string = "contabilidadeBalanco/salvar";
    return this.utilService.postJSON(urlObtencaoDados, relatorio);
  }

  /* ======================================================================
  *
  *  Requisiçoes de Arquivo
  *
  ========================================================================= */

  listarArquivos(relatorio): Observable<any> {
    let urlObtencaoDados: string = "arquivoBalanco/listar/" + relatorio.idContabilidadeBalanco;
    return this.utilService.getJSON(urlObtencaoDados);
  }


  deletarArquivo(arquivo): Observable<any> {
    let urlObtencaoDados: string = "arquivoBalanco/deletar/" + arquivo.idArquivoBalanco;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public downloadfile(arquivo: any) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("arquivoBalanco/download/" + arquivo.idArquivoBalanco)
      .subscribe(data => {

        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, arquivo.nmArquivo);
      },
      error => console.log("Error downloading the file. error: " + error));
  }

  public salvarArquivo(event, orcamento) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "arquivoBalanco/salvar?idContabilidadeBalanco=" + orcamento.idContabilidadeBalanco;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/relatorios-contabeis-service.ts